/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Toast_Reject_PxkInputs */

const vi_pkl_toast_reject_pxk = /** @type {(inputs: Pkl_Toast_Reject_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã từ chối phiếu`)
};

/**

* @param {Pkl_Toast_Reject_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_toast_reject_pxk = /** @type {((inputs?: Pkl_Toast_Reject_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Toast_Reject_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_toast_reject_pxk(inputs)
});